var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSendPlaneLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.923 9.36998C1.413 9.16498 1.419 8.85998 1.957 8.68098L21.043 2.31898C21.572 2.14298 21.875 2.43898 21.727 2.95698L16.273 22.043C16.123 22.572 15.798 22.596 15.556 22.113L11 13L1.923 9.36998ZM6.813 9.16998L11.5 11L16 8.5L13 12.5L15.489 17.507L19.035 5.09698L6.812 9.16998H6.813Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSendPlaneLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send-plane-line.ae16b303ea8f2d5e148424aede55f320.svg";